<template>
  <div class="addresslist">
    <div class="myspespace"></div>
    <div class="in">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-radio-group v-model="radio">
          <div class="item" :class="{'focus': item.address_id === address_id}" v-for="(item, index) in dataList" :key="index" >
            <div class="itemin">
              <div class="top" @click="subConFirm(item)">
                <div class="title"><span>{{item.username}}</span><span>{{item.telephone}}</span></div>
                <div class="des">{{item.province}} {{item.city}} {{item.county}} {{item.adrdetail}}</div>
              </div>
              <div class="bottom">
                <div class="left"><van-radio @click.stop="setDefault(item)" :name="index">默认地址</van-radio></div>
                <div class="right"><van-button @click.stop="deleteItem(item)" class="mybtn" plain type="primary">删除</van-button><van-button @click.stop="updateItem(item)" class="mybtn" plain type="primary">编辑</van-button></div>
              </div>
            </div>
          </div>
        </van-radio-group>
      </van-list>
      <van-button class="mybtn2" type="primary" @click="gotoAdd" block>新增</van-button>
      <div class="spaddresslist"></div>
    </div>
  </div>
</template>

<script>
import { addressList, deleteItem, updateAddress } from '@/api/modules/address'
import { Dialog, Toast } from 'vant'
export default {
  name: 'addresslist',
  components: {
  },
  data() {
    return {
      radio: -1,
      subdata: {
        value1: ''
      },
      loading: false,
      finished: false,
      dataList: [],
      address_id: '',
      searchOptions: {
        'keywords': '',
        'orderStatus': '全部'
      },
      searchPage: {
        'page': 0,
        'pageSize': 10
      },
      choosedData: null
    }
  },
  computed: {
  },
  beforeRouteLeave (to, from, next) {
    if (this.choosedData) {
      to.query.type = this.$route.query.type
      to.query.province = this.choosedData.province
      to.query.city = this.choosedData.city
      to.query.county = this.choosedData.county
      to.query.address_id = this.choosedData.address_id
      to.query.adrdetail = this.choosedData.adrdetail
      to.query.username = this.choosedData.username
      to.query.telephone = this.choosedData.telephone
    }
    // to.query.address_id =
    next()
  },
  /*
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 从用户选择返回
      console.log(vm)
    })
  },*/
  created() {
    this.address_id = this.$route.query.address_id
    /*
    addressList().then((res) => {
      console.log(res)
    })*/
  },
  methods: {
    setDefault(item) {
      item.is_def = '1'
      updateAddress({...item}).then((res) => {
        if (res.status_code === 200) {
          Toast('更新成功')
        }
      })
    },
    gotoAdd() {
      this.$router.push('/sf/addaddress')
    },
    jumpDetail() {
      this.$router.push('/sf/addaddress')
    },
    onLoad() {
      this.searchPage.page++
      this.loadData()
    },
    updateItem(item) {
      this.$router.push({ path: '/sf/addaddress', query: { address_id: item.address_id }})
    },
    subConFirm(item) {
      this.choosedData = item
      this.$router.back()
    },
    reSearch() {
      this.dataList = []
      this.searchPage.page = 1
      this.loadData()
    },
    deleteItem(item) {
      Dialog.confirm({
        title: '确认',
        message: '确认删除地址'
      })
        .then(() => {
          deleteItem({
            'address_id': item.address_id
          }).then((res) => {
            if (res.status_code === 200) {
              Toast('删除成功')
              this.reSearch()
            }
          })
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    },
    loadData() {
      const params = Object.assign({}, this.searchPage, this.searchOptions)
      addressList(params).then((res) => {
        if (res.data.status_code === 200) {
          this.dataList.push(...res.data.list)
          this.dataList.forEach((item, index) => {
            if (item.is_def === '1') {
              this.radio = index
            }
          })
          if(this.radio === -1) {
            this.radio = 0
          }
          // 这里表示最后一页
          if (this.searchPage.page * this.searchPage.pageSize >= res.data.total_count || res.data.list.length === 0) {
            this.loading = true
            this.finished = true
          }
          else {
            this.finished = false
            this.loading = false
          }
        }
      })
    }
  }
}
</script>
<style lang="less">
  .addresslist{
    .van-list__finished-text{
      font-size:24px;
    }
    .spaddresslist{
      height:120px;
    }
    .van-icon{
      font-size:30px;
    }
    .van-radio__label{
      margin-top:14px;
    }
    .van-radio{
      height:70px;
    }
  }

</style>
<style lang="less" scoped>
.addresslist{
  min-height:100vh;
  background-color: #f4f5fb;
  .mybtn2{
    width: 750px;
    height: 94px;
    font-weight: 500;
    font-size: 36px;
    color: #000000;
    line-height: 48px;
    background-color:#ffffff;
    border:0px;
  }
  .in{
    margin:0px 15px;
    .item{
      width: 722px;
      min-height: 211px;
      background: #FFFFFF;
      box-shadow: 0px 6px 10px 0px rgba(0,0,0,0.02);
      border-radius: 20px;
      margin-bottom: 20px;
      .itemin{
        margin:0px 30px;
        .top{
          border-bottom:1px solid #F2F2F2;
          .title{
            font-weight: 400;
            font-size: 30px;
            color: #333333;
            line-height: 44px;
            margin-bottom:20px;
            padding-top:10px;
            span{
              margin-right:30px;
            }
          }
          .des{
            font-weight: 400;
            font-size: 24px;
            color: #9A9A9A;
            line-height: 32px;
            margin-bottom:30px;
          }
        }
        .bottom{
          display:flex;
          .left{
            flex:1;
            font-weight: 400;
            font-size: 24px;
            color: #333333;
            line-height: 32px;
          }
          .right{
            flex:1;
            .mybtn{
              border-radius: 10px;
              border: 2px solid #C4C4C4;
              color:#C4C4C4;
              float:right;
              margin-top:20px;
              margin-right:20px;
            }
          }
        }
      }
    }
    .focus{
      border: 2px solid #777777;
    }
  }
}
</style>
